const immer = require('immer')
const { packageName } = require('./config')

const createConstant = (service, actionName, pkg = packageName) => `${pkg}/${service}/${actionName}`
const createAction = (constant, payload) => ({
  type: constant,
  payload,
})

const createReducer = (handlers, initialState = {}) => (
  state = initialState,
  action,
) => immer.produce(state, draft => {
  const handler = handlers[action.type]
  if (!handler) {
    return state
  }
  const nextState = handler(draft, action)
  return { ...draft, ...nextState }
})

module.exports = {
  createConstant,
  createAction,
  createReducer,
}
